export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}skill/user-skill/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        tree: {
            method: 'GET',
            isArray: true,
            url: `${url}/tree`
        },
        search: {
            method: 'POST',
            isArray: true,
            url: `${url}/search`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/User/Skill/index.js